import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConfiguratorCreateJobForArHelperMutationVariables = Types.Exact<{
  input: Types.MutationConfiguratorCreateJobInput;
}>;


export type ConfiguratorCreateJobForArHelperMutation = { __typename: 'Mutation', configuratorCreateJob: { __typename: 'ConfiguratorArJob', id: string } };

export type ConfiguratorJobTaskForArHelperQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ConfiguratorJobTaskForArHelperQuery = { __typename: 'Query', configuratorJobTask?: { __typename: 'ConfiguratorArJobTask', id: string, state: Types.JobState, output?: any | null } | null };

export type ConfiguratorAllGltfAssignmentsQueryVariables = Types.Exact<{
  filter: Types.DataObjectAssignmentFilterInput;
}>;


export type ConfiguratorAllGltfAssignmentsQuery = { __typename: 'Query', configuratorDataObjectAssignments: Array<{ __typename: 'ConfiguratorArAssignment', id: string }> };

export type ConfiguratorGltfDataObjectAssignmentsQueryVariables = Types.Exact<{
  filter: Types.DataObjectAssignmentFilterInput;
}>;


export type ConfiguratorGltfDataObjectAssignmentsQuery = { __typename: 'Query', configuratorDataObjectAssignments: Array<{ __typename: 'ConfiguratorArAssignment', id: string, dataObject: { __typename: 'ConfiguratorArAssignmentDataObject', id: string } }> };

export type ConfiguratorCreateDataObjectAssignmentForArHelperMutationVariables = Types.Exact<{
  input: Types.MutationConfiguratorCreateDataObjectAssignmentInput;
}>;


export type ConfiguratorCreateDataObjectAssignmentForArHelperMutation = { __typename: 'Mutation', configuratorCreateDataObjectAssignment: { __typename: 'ConfiguratorArAssignment', id: string } };

export type DeleteDataObjectAssignmentForArHelperMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteDataObjectAssignmentForArHelperMutation = { __typename: 'Mutation', deleteDataObjectAssignment?: any | null };

export type DeleteDataObjectForArHelperMutationVariables = Types.Exact<{
  dataObjectId: Types.Scalars['ID']['input'];
}>;


export type DeleteDataObjectForArHelperMutation = { __typename: 'Mutation', deleteDataObject?: any | null };

export const ConfiguratorCreateJobForArHelperDocument = gql`
    mutation configuratorCreateJobForArHelper($input: MutationConfiguratorCreateJobInput!) {
  configuratorCreateJob(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorCreateJobForArHelperGQL extends Apollo.Mutation<ConfiguratorCreateJobForArHelperMutation, ConfiguratorCreateJobForArHelperMutationVariables> {
    override document = ConfiguratorCreateJobForArHelperDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorJobTaskForArHelperDocument = gql`
    query configuratorJobTaskForArHelper($id: ID!) {
  configuratorJobTask(id: $id) {
    id
    state
    output
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorJobTaskForArHelperGQL extends Apollo.Query<ConfiguratorJobTaskForArHelperQuery, ConfiguratorJobTaskForArHelperQueryVariables> {
    override document = ConfiguratorJobTaskForArHelperDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorAllGltfAssignmentsDocument = gql`
    query configuratorAllGltfAssignments($filter: DataObjectAssignmentFilterInput!) {
  configuratorDataObjectAssignments(filter: $filter) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorAllGltfAssignmentsGQL extends Apollo.Query<ConfiguratorAllGltfAssignmentsQuery, ConfiguratorAllGltfAssignmentsQueryVariables> {
    override document = ConfiguratorAllGltfAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorGltfDataObjectAssignmentsDocument = gql`
    query configuratorGltfDataObjectAssignments($filter: DataObjectAssignmentFilterInput!) {
  configuratorDataObjectAssignments(filter: $filter) {
    id
    dataObject {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorGltfDataObjectAssignmentsGQL extends Apollo.Query<ConfiguratorGltfDataObjectAssignmentsQuery, ConfiguratorGltfDataObjectAssignmentsQueryVariables> {
    override document = ConfiguratorGltfDataObjectAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorCreateDataObjectAssignmentForArHelperDocument = gql`
    mutation configuratorCreateDataObjectAssignmentForArHelper($input: MutationConfiguratorCreateDataObjectAssignmentInput!) {
  configuratorCreateDataObjectAssignment(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorCreateDataObjectAssignmentForArHelperGQL extends Apollo.Mutation<ConfiguratorCreateDataObjectAssignmentForArHelperMutation, ConfiguratorCreateDataObjectAssignmentForArHelperMutationVariables> {
    override document = ConfiguratorCreateDataObjectAssignmentForArHelperDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDataObjectAssignmentForArHelperDocument = gql`
    mutation deleteDataObjectAssignmentForArHelper($id: ID!) {
  deleteDataObjectAssignment(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDataObjectAssignmentForArHelperGQL extends Apollo.Mutation<DeleteDataObjectAssignmentForArHelperMutation, DeleteDataObjectAssignmentForArHelperMutationVariables> {
    override document = DeleteDataObjectAssignmentForArHelperDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDataObjectForArHelperDocument = gql`
    mutation deleteDataObjectForArHelper($dataObjectId: ID!) {
  deleteDataObject(id: $dataObjectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDataObjectForArHelperGQL extends Apollo.Mutation<DeleteDataObjectForArHelperMutation, DeleteDataObjectForArHelperMutationVariables> {
    override document = DeleteDataObjectForArHelperDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }